import { Action } from 'typescript-fsa/lib';
import {
  addFailedZoneId,
  removeFailedZoneId,
  resetMediaForZoneId,
  updateMediaEntities,
  uploadMedia,
  UploadMedia,
} from './media.actions';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { callApi } from '../../api';
import { postImageCallOptions } from '../../../services/media.service';
import * as R from 'ramda';

export function* watchForUploadMedia() {
  yield takeEvery(uploadMedia.type, function*(action: Action<UploadMedia>) {
    const {
      payload: { file, zoneId },
    } = action;
    try {
      yield put(removeFailedZoneId({ zoneId }));
      const { auth } = yield select();
      if (!auth.token) {
        throw new Error('Not Logged in!');
      }
      yield put(
        resetMediaForZoneId({
          zoneId,
        })
      );
      const { ok, data } = yield doUpload(auth.token, file);
      if (ok) {
        yield put(
          updateMediaEntities({
            mediaItems: R.zipObj([data.id], [{ ...data, zoneId }]),
          })
        );
      } else {
        yield put(
          addFailedZoneId({
            zoneId,
          })
        );
      }
    } catch (e) {
      console.error('ERROR', e);
    }
  });
}

function* doUpload(token: string, file: File) {
  const formData = new FormData();
  formData.append('upload', file);
  return yield call(callApi, postImageCallOptions(formData));
}



// WEBPACK FOOTER //
// ./src/store/Entities/Media/media.saga.ts